//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
export default {
  name: 'SurveyLayout',
  computed: {
    bgImage: get('theme/bgImage'),
    logo: get('theme/logo'),
    theme: get('theme/theme'),
    headerStyles: function headerStyles() {
      return "\n      background: linear-gradient(130deg, ".concat(this.theme.gradientColorStart, ", ").concat(this.theme.gradientColorStart, " 20%, ").concat(this.theme.gradientColorEnd, ");\n    ");
    }
  }
};